@app.directive 'matrixItemCircle', ->
  restrict: 'E'
  scope: {}
  controller: ->

    this
  controllerAs: 'matrixItemCircle'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemCircle/matrixItemCircle.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    loadImageOnEnterViewport: '='
    track: '&'
  }
